export const WIZARD_STEPS = [
  { key: 1, label: 'Basic Info' },
  { key: 2, label: 'Salary & Details' },
  { key: 3, label: 'Description' },
  { key: 4, label: 'Application' },
  { key: 5, label: 'Review' },
];

export const EMPLOYMENT_TYPES = [
  { value: 'full-time', label: 'Full-time' },
  { value: 'part-time', label: 'Part-time' },
  { value: 'contract', label: 'Contract' },
  { value: 'freelance', label: 'Freelance' },
];

export const SENIORITY_OPTIONS = [
  { value: 'entry', label: 'Entry Level' },
  { value: 'mid', label: 'Mid-Level' },
  { value: 'senior', label: 'Senior' },
  { value: 'lead', label: 'Lead / Principal' },
];

export const LOCATION_OPTIONS = [
  'Worldwide',
  'Europe only',
  'US only',
  'Americas',
  'EMEA',
  'APAC',
];

export const LOCATION_SPECIFIC_COUNTRY = '__specific_country__';

export const SALARY_CURRENCIES = ['EUR', 'USD', 'GBP'];

export const SALARY_PERIODS = [
  { value: 'yearly', label: 'Per year' },
  { value: 'monthly', label: 'Per month' },
  { value: 'hourly', label: 'Per hour' },
  { value: 'project', label: 'Per project' },
];

export const APPLICATION_METHODS = [
  { value: 'external_url', label: 'External URL' },
  { value: 'email', label: 'Email' },
  { value: 'rwm_flow', label: 'RWM Flow' },
];

export function countWords(text) {
  const plain = String(text || '')
    .replace(/<[^>]+>/g, ' ')
    .trim();
  if (!plain) return 0;
  return plain.split(/\s+/).filter(Boolean).length;
}

export function seniorityFromSelection(selection) {
  return SENIORITY_OPTIONS.map((o) => o.value).filter((v) => selection[v]);
}

export function seniorityToSelection(levels) {
  const base = { entry: false, mid: false, senior: false, lead: false };
  if (!Array.isArray(levels)) return base;
  levels.forEach((l) => {
    if (Object.prototype.hasOwnProperty.call(base, l)) base[l] = true;
  });
  return base;
}

